<script>
export default {
  name: "FeeLogger",
  props: {
    params: {
      type: Object,
      required: true
    },
    close: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      columns: [
        {type: 'index', title: '序号', width: 70, align: 'center', fixed: 'left'},
        {title: '操作时间', key: 'createTime', width: 220, align: 'center', tooltip: true, fixed: 'left'},
        {title: '代码', key: 'action', width: 160, align: 'center', tooltip: true, fixed: 'left'},
        {title: '操作人', key: 'operator', width: 140, align: 'center', tooltip: true, fixed: 'left'},
        {title: '描述', key: 'desc', width: 290, align: 'center', tooltip: true, fixed: 'left'},
      ]
    }
  }
}
</script>

<template>
  <Table :columns="columns" :data="params.recordLogger" border :height="500" />
</template>

<style scoped>

</style>
